<div class="cap-error-holder">
  <ng-content></ng-content>
  <span class="error" [id]="'errorFormControl-' + label" *ngIf="!hideError"></span>
</div>
